import React, { ComponentProps } from 'react';
import Dropdown from '@common/components/dropdown';
import { Button } from '@common/components/button';

type Props = Omit<ComponentProps<typeof Dropdown>, 'toggle' | 'alignRight' | 'portal'> & {
  portal?: boolean; // Allow override, but default to false for tables
};

export const TableDropdown = ({ children, disabled, portal = false, ...props }: Props) => (
  <Dropdown
    {...props}
    alignRight
    portal={portal}
    disabled={disabled}
    toggle={(
      <Button
        icon="more_vert"
        className="Table__DropdownTrigger"
        disabled={!!props.disabled}
      />
    )}
  >
    {children}
  </Dropdown>
);

TableDropdown.Item = Dropdown.Item;
TableDropdown.SubMenu = Dropdown.SubMenu;
